import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SocialReviewsModal extends Component {
  render() {
    return (
      <div className="social-reviews-modal">
        <h4 className="modal-title" style={{ fontSize: 18 }}>
          Reviews Summary Widget
        </h4>
        <div className="figures">
          <div className="figure">
            <img src="https://publisher-assets.spot.im/host-panel/social-reviews.png" />
            <span className="label social-label">
              For optimal usabilty of the Reviews Summary Widget, consider placing it in the top
              area of your page.
            </span>
          </div>
        </div>
        <div className="button-container">
          <div className="confirm-button social-button" onClick={this.props.onClose}>
            Got it!
          </div>
        </div>
      </div>
    );
  }
}

SocialReviewsModal.displayName = 'SocialReviewsModal';

SocialReviewsModal.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default SocialReviewsModal;
